import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import CustomInspectionsContainer from './CustomInspectionsContainer';
const queryClient = new QueryClient();
export default function CustomInspections() {
    return (React.createElement(QueryClientProvider, { client: queryClient },
        React.createElement(CustomInspectionsContainer, null)));
}
